module.exports = __webpack_public_path__ + "assets/ccase.3f838438581fa5b41d4051b431d4d01d.png";